export enum ACTIVE_SECTIONS {
  Active = 'active',
  Apply = 'apply',
  BgSwitchDeclarations = 'bgSwitchDeclarations',
  Contact = 'contact',
  ContactDetails = 'contactDetails',
  Finance = 'finance',
  Funding = 'funding',
  SecurityType = 'securityType',
  Identify = 'identify',
  Pay = 'pay',
  Process = 'process',
  Submitted = 'submitted',
  Supplier = 'supplier'
}
